import React, { Component } from "react";

//Component Imports
import GameController from "../GameController";
import VideoOffNotice from "../VideoOffNotice";

//Tables
//Table for Lotto
import LottoTable from "../LottoTable";
import LottoTabs from "../LottoTable/tabs";

//Table for Shio Balls
import ShioBallsTable from "../ShioBallsTable";
import ShioBallsTabs from "../ShioBallsTable/tabs";

//Virtual Ball Component Imports
import LottoVirtualBalls from "../LottoVirtualBalls";

//Table for 5D / Five D
import FiveDTable from "../FiveDTable";
import FiveDTabs from "../FiveDTable/tabs";

import PinballTable from "../PinballTable";

import {
	isBetClosed,
	getTranslatedGameName,
	GameStatistics,
	History,
	Table,
} from "@/modules/commonMobile";

import { assetImg } from "@/modules/moduleImporter";
import thousandsFormat from "@/modules/thousandsFormat";

//Type Imports
import { IMaximisedGameProps } from "@/types/GlobalTypes";

//Image Imports

import img_small_fullscreen from "@/assets/img/svg/sidemenu/fullscreen.svg";
import img_multibet_restore from "@/assets/img/svg/buttons/restore.svg";

import img_bet_closed_multi_table from "@/assets/img/img_bet_closed_multi_table.png";
import { renderModals } from "@/modules/modals";
import { getAssetPcode, getBasePcode, isMachineGame } from "@/modules/gamePcode";

interface IState {
	winNumberGif: any;
	winNumberGifs: any;
}

export default class MaximizeMachineGame extends Component<IMaximisedGameProps, IState> {
	win: any;

	constructor(props: IMaximisedGameProps) {
		super(props);
		this.state = {
			winNumberGif: null,
			winNumberGifs: null
		};
	}

	componentDidUpdate(prevProps, prevState) {
		const activeGame = this.props.data;

		//WinNumberGif for old games

		//Only evaluate active games
		if (activeGame.active) {
			// console.log("wins: " + activeGame.win, prevProps.data.win);
			if (this.win !== activeGame.win) {
				const pcode = activeGame.pcode;
				const basePcode = getBasePcode(pcode);
				const assetPcode = getAssetPcode(pcode);
				// const winNumberGif = activeGame.win_number_gif;
				const win = activeGame.win;

				window.setTimeout(() => {
					const dom = document.getElementById("wng_" + basePcode) as HTMLElement;
					if (dom !== null)
						dom.className += " appear";
				}, 100);

				this.win = win;

				if (!win) return;

				const wins = win.split(",");
				this.setState({
					winNumberGifs:
						wins.map((item, idx) =>
							assetImg("win_number_gif_" + assetPcode,
								item + ".gif?a=" + Math.random(),
								"ohrss_" + pcode + "_" + idx)
						)
				});
			}
		}
	}

	private get activeGame() {
		return this.props.data;
	}

	private get betClosed() {
		return isBetClosed(this.secondsLeft);
	}

	private get secondsLeft() {
		return this.props.timerData ? this.props.timerData.time : 0;
	}

	private get timeText() {
		let output = "";
		const { secondsLeft } = this;

		const min = Math.floor(secondsLeft / 60);
		const sec = (secondsLeft % 60 + "").padStart(2, "0");
		output = `${min}:${sec}`;

		return output;
	}

	/**
	 * Don't render if there are more than 1 active game
	 */
	private get isSingleGame() {
		return this.props.activeGameCount === 1;
	}

	private get pcodeProp() {
		const { pcode } = this.activeGame;
		return ({ pcode });
	}

	private headerFragment() {
		const activeGamePcodes = this.props.activeGamePcodes || [];

		const { activeGame, pcodeProp } = this;
		const { maximiseGame, restoreGames, lang, closeGame } = this.props;
		const { maximised, pcode, periode } = activeGame;

		return (
			<div className="header">
				{assetImg("game_icon", pcode + "_wh.svg", "", "logo")}
				{
					// <img src={this.props.white_icon} className="logo" alt={activeGame.name} />
				}
				<p className="name">
					{getTranslatedGameName(lang, pcode)}
				</p>
				<p className="periode">P {periode}</p>

				{
					!maximised
						? (
							<img className={"maximise"}
								src={img_small_fullscreen}

								{...pcodeProp}

								onClick={maximiseGame}
								alt="maximise" />
						) : null
				}

				{
					activeGamePcodes.length > 0 &&
						activeGame.maximised ?
						<img className="restore"
							src={img_multibet_restore}

							{...pcodeProp}

							onClick={restoreGames}
							alt="restore" />
						: null
				}

				{/* <i className={"sl-ic-close close"}
					{...{ game: pcode }}
					onClick={closeGame} /> */}
			</div>
		);
	}

	/**
	 * Shorthand to get pcode
	 */
	private get pcode() {
		return this.activeGame.pcode;
	}

	private get basePcode() {
		return getBasePcode(this.activeGame.pcode)
	}

	private streamingFragment() {
		const
			{ activeGame, betClosed, pcode } = this,
			{ enableStreaming, lang, isLoadingStreaming } = this.props,
			{ streamObj } = activeGame,

			classNames = [
				"stream-container",
				(enableStreaming ? "has-streaming" : "no-streaming"),
				(betClosed ? " bet-closed" : ""),
				pcode
			].join(" ");

		return (
			<div className={classNames}>
				{enableStreaming ? streamObj : null}

				<VideoOffNotice
					langdata={lang}
					enableStreaming={enableStreaming}
					isLoadingStreaming={isLoadingStreaming}
					isDesktop={true}
				/>
			</div>
		);
	}

	private winGifFragment() {
		if (!this.activeGame.win)
			return null;

		const
			{ basePcode } = this,
			{ winNumberGif, winNumberGifs } = this.state,
			{ lang } = this.props;

		return (
			// Show win number GIF
			<div id={"wng_" + basePcode}
				className="win-number-gif">
				<p>{lang["txt_result"]}</p>
				{winNumberGif}
				{winNumberGifs}

				{
					basePcode === "m29" ? (
						<div className="kop-kepala-ekor">
							<div>
								{lang["txt_m29_first"]}
							</div>
							<div>
								{lang["txt_m29_middle"]}
							</div>
							<div>
								{lang["txt_m29_last"]}
							</div>
						</div>
					) : null
				}
			</div>
		);
	}

	private totalBetWinFragment() {
		const
			{ activeGame, isSingleGame } = this,
			{ lang, userdata } = this.props,
			{ totalBet, totalWin } = activeGame;

		return (
			<div className="details">
				<div className="total-bet">
					<p className="desc-heading">
						{lang["txt_total_bet"]}
					</p>

					<p className="desc-content">
						{thousandsFormat(totalBet, userdata.user.lang)}
					</p>
				</div>

				{
					isSingleGame
						? (
							<div className="total-win">
								<p className="desc-heading">
									{lang["txt_total_win"]}
								</p>

								<p className="desc-content">
									{thousandsFormat(totalWin, userdata.user.lang)}
								</p>
							</div>
						) : null
				}
			</div>
		);
	}

	private timeLeftFragment() {
		const
			{ betClosed, isSingleGame, secondsLeft, timeText } = this,
			{ lang } = this.props;

		return (
			<div className="group-timer">
				{ /* Single game timer component */}
				{
					isSingleGame ? (
						betClosed ?
							<div className="bet-closed-text">{lang["txt_wait_next_round"]}</div> :
							secondsLeft > 5 ?
								<div className="bet-open-text">{lang["txt_place_bet"]}</div> :
								<div className="bet-closing-text">{lang["txt_bet_close_in"]}</div>
					) : null
				}

				{
					//Copied from MaximizeGame
				}
				<div className={"timer" +
					(
						betClosed
							? " bet-closed"
							: secondsLeft > 5
								? " bet-open"
								: " bet-closing")}>
					{
						betClosed ?
							<img src={img_bet_closed_multi_table} alt="bet closed" /> :
							timeText
					}
				</div>
			</div>
		);
	}

	private historyStatisticsFragment() {
		const
			{ activeGame, isSingleGame, pcode, pcodeProp } = this,
			{ activeGameCount, lang, toggleLobbyHistory, toggleGameStatistics } = this.props,
			{ history: historyProperty, historyBlink, roadmapFilters } = activeGame;

		return (
			/* History and Statistics container */
			isSingleGame ? (
				<div className="history-statistics-container">
					<table className="roadmap-tabs">
						<tbody>
							<tr>
								{/* History */}
								<td {...pcodeProp}
									// always active for machine games
									className={"roadmap-tab active"}
									onClick={toggleLobbyHistory}
								>
									{lang["txt_history"]}
								</td>

								{/* Statistics */}
								{
									<td {...pcodeProp}
										className={"roadmap-tab first-only active"}
										onClick={toggleGameStatistics}>
										{
											pcode === "m26" ?
												lang["txt_statistics_first"] :
												lang["txt_statistics"]
										}
									</td>
								}
							</tr>
						</tbody>
					</table>

					<History
						pcode={pcode}
						history={historyProperty}
						historyBlink={historyBlink}
						activeGameCount={activeGameCount}
						langdata={lang}
					/>

					<GameStatistics
						pcode={pcode}
						history={historyProperty}
						filters={roadmapFilters}
						langdata={lang}
					/>
				</div>
			) : null
		);
	}

	/**
	 * Special Running Tickets container for m26, derived from m7 and m19
	 */
	private runningTicketsFragment() {
		const
			{ activeGame, pcode, pcodeProp } = this,
			{ activeGameCount, lang, removeTicket } = this.props,
			{ history, historyBlink, mustSubmitTickets, tickets } = activeGame;

		return (
			<div className={"history-statistics-container ticket-container " + pcode}>
				<table className="roadmap-tabs">
					<tbody>
						<tr>
							<td {...pcodeProp}
								className={"roadmap-tab active"}>
								{lang["txt_running_tickets"]}
							</td>
						</tr>
					</tbody>
				</table>

				<History
					pcode={pcode}
					history={history}
					historyBlink={historyBlink}
					activeGameCount={activeGameCount}
					type="ticket"
					langdata={lang}
					tickets={tickets}

					mustSubmitTickets={mustSubmitTickets}
					removeTicket={removeTicket}
				/>
			</div>
		);
	}

	private tableDescFragment() {
		const
			{ activeGame } = this,
			{ lang, userdata } = this.props

		return (
			<table className="table-desc">
				<tbody>
					<tr>
						<td>
							<div className="desc-heading">
								{lang["txt_table_name"]}
							</div>
							<div className="desc-content">
								{userdata.user.table}
							</div>
						</td>
					</tr>

					<tr>
						<td>
							<div className="desc-heading">
								{lang["txt_periode"]}
							</div>

							<div className="desc-content">
								{activeGame.periode}
							</div>
						</td>
					</tr>
					<tr className="table-limit-bet">
						<td className="desc-heading">{lang["txt_bet_limit"]}</td>
					</tr>
					<tr>
						<td>
							<br />

							<div className="desc-heading">
								{lang["txt_min_number"]}
							</div>

							<div className="desc-content">
								{thousandsFormat(activeGame.min, userdata.user.lang)}
							</div>

							<br />

							<div className="desc-heading">
								{lang["txt_max_number"]}
							</div>

							<div className="desc-content">
								{thousandsFormat(activeGame.max, userdata.user.lang)}
							</div>

							<br />

							<div className="desc-heading">
								{lang["txt_min_50"]}
							</div>

							<div className="desc-content">
								{thousandsFormat(activeGame.min50, userdata.user.lang)}
							</div>

							<br />

							<div className="desc-heading">
								{lang["txt_max_50"]}
							</div>

							<div className="desc-content">
								{thousandsFormat(activeGame.max50, userdata.user.lang)}
							</div>

							<br />

							<div className="desc-heading">
								{lang["txt_detail"]}
							</div>

							<div className="desc-content">
								1K = {thousandsFormat(1000, userdata.user.lang)}
							</div>

							<br />
						</td>
					</tr>
				</tbody>
			</table>
		);
	}

	private bettingTabFragment() {
		const
			{ activeGame, betClosed, pcode } = this,
			{ activateBetGroup } = this.props,
			commonProps = {
				game: activeGame,
				activateBetGroup
			};

		return (
			pcode === "m26" ? (
				<LottoTabs
					isBetClosed={betClosed}
					{...commonProps}
				/>
			) : pcode === "m29" ? (
				<ShioBallsTabs {...commonProps} />
			) : pcode === "m30" ? (
				<FiveDTabs {...commonProps} />
			) : null
		)
	}

	private bettingTableFragment() {
		const
			{ activeGame, pcode } = this,
			{
				activateUnsubmittedTicketRow,
				addUnsubmittedTicketRow,
				lang,
				insertBet,
				removeBet,

				removeNumberM26,
				removeAnimal,
				removeNumberM30,
				removeNumberM42
			} = this.props,
			commonProps = {
				activeGame,
				langdata: lang,
				insertBet,
				removeBet,
				mobile: false,
				activateUnsubmittedTicketRow,
				addUnsubmittedTicketRow
			}

		return (
			//Table for Lotto
			pcode === "m26"
				? (
					<LottoTable
						{...{
							removeNumberM26,
							...commonProps
						}}
					/>
				) : pcode === "m29" ? (
					<ShioBallsTable
						{...{
							removeAnimal,
							...commonProps
						}}
					/>
				) : pcode === "m30" ? (
					<FiveDTable
						{...{
							removeNumberM30,
							...commonProps
						}}
					/>
				) : pcode === "m42" ? (
					<PinballTable
						{...{
							removeNumberM42,
							...commonProps
						}}
					/>
				) : null
		);
	}

	/**
	 * div.min
	 */
	private leftFragment() {
		const
			{ activeGame } = this,
			{ lang } = this.props,
			{ lottoResult, pcode } = activeGame;

		return (
			<div className="min">
				{this.streamingFragment()}
				{this.winGifFragment()}
				{this.totalBetWinFragment()}
				{this.timeLeftFragment()}
				{this.historyStatisticsFragment()}

				{this.runningTicketsFragment()}
				{this.tableDescFragment()}

				{this.bettingTabFragment()}
				{this.bettingTableFragment()}

				{
					pcode !== "m32" &&
						//Lotto Virtual Balls: for Lotto, Shio Balls & Sicbo Machine
						lottoResult ? (
						<LottoVirtualBalls
							activeGame={activeGame}
							langdata={lang}
							lottoResult={lottoResult}
						/>
					) : null
				}
			</div>

		);
	}

	/**
	 * div.max
	 */
	private rightFragment() {
		const
			{ activeGame } = this,
			{ insertBet, chipBase, addNumberM26, addAnimal, addNumberM30, addNumberM42, lang,
				undoBet, clearBet, reBet, sendBet } = this.props,
			{ disableUndoBet, disableClearBet, disableRebet, disableSubmitBet, pcode } = activeGame;

		return (
			<div className="max">
				<div className="table machine">
					<Table
						data={activeGame}
						pcode={pcode}
						insertBet={insertBet}
						chipBase={chipBase}
						langdata={lang}

						// Lotto
						addNumberM26={addNumberM26}

						// for Shio Fights
						addAnimal={addAnimal}

						addNumberM30={addNumberM30}

						// Pinball
						addNumberM42={addNumberM42}
					/>
				</div>

				<div className="controller">
					<GameController
						disabled={disableUndoBet}
						clickFunction={undoBet}
						controllerClass={"sl-red-sh"}
						pcode={pcode}
						controllerValue={lang["txt_undo"]} />

					<GameController
						disabled={disableClearBet}
						clickFunction={clearBet}
						controllerClass={"sl-blue-sh"}
						pcode={pcode}
						controllerValue={lang["txt_clear"]} />

					<GameController
						disabled={disableRebet}
						clickFunction={reBet}
						controllerClass={"sl-yellow-sh"}
						pcode={pcode}
						controllerValue={lang["txt_rebet"]} />

					<GameController
						disabled={disableSubmitBet}
						clickFunction={sendBet}
						controllerClass={"sl-green-sh"}
						pcode={pcode}
						controllerValue={lang["txt_submit"]} />
				</div>
			</div>
		);
	}

	render() {
		const { activeGame } = this;
		const { lang } = this.props;

		const { maximised } = activeGame;

		const pcode = activeGame.pcode;

		if (!this.isSingleGame ||
			!activeGame.active)
			return null;

		const classNames = [
			"sl-game",
			(maximised ? "sl-single-game machine-game" : "sl-multi-table")
		].join(" ");

		return (
			<div
				className={classNames}
				// FindDOMNode Replacement
				{... { "data-pcode": pcode }}>

				{this.headerFragment()}
				{this.leftFragment()}
				{this.rightFragment()}

				{
					/* MODALS */
					renderModals(
						activeGame,
						lang.language_code,
						this.props.clearModalsWithPcode
					)
				}
			</div>
		);
	}
}
